import React from 'react';
import classNames from 'classnames/bind';

import styles from './counterStyles';

import {
  userAccountIdeasUrl,
  userAccountFollowingUrl,
  userAccountFollowersUrl
} from 'buyside/util/urlHelper';

const cx = classNames.bind(styles);

const Counter = ({ count, title, type }) => {
  const isSmall = type === 'small';

  const linkDestination = {
    Followers: userAccountFollowersUrl(),
    Following: userAccountFollowingUrl(),
    Ideas: userAccountIdeasUrl()
  };

  return (
    <div className={styles.counterWrap}>
      <a href={linkDestination[title]}>
        <div className={cx({ number: true, small: isSmall })}>{count}</div>
        <div className={cx({ text: true, small: isSmall })}>{title}</div>
      </a>
    </div>
  );
};

export default Counter;
